import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
export const ActivityStreakMonthStatCard = ({ classObject, icon, label, value }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.valueRow) },
            icon,
            React.createElement("span", { className: css(styles.value) }, value)),
        React.createElement("span", { className: css(styles.label) }, label)));
};
const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.White,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 4,
        flex: 1,
        padding: 12,
        borderRadius: 10,
    },
    valueRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
    value: {
        color: Colors.TextDark,
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '100%',
        letterSpacing: 0.8,
    },
    label: {
        color: Colors.GrayDarkest,
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '100%',
        letterSpacing: 0.48,
    },
});
